module.exports = __webpack_public_path__ + "a37b0c01c0baf1888ca812cc0508f6e2.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/MaterialIcons-Regular.ttf
// module id = 540
// module chunks = 0